module.exports = __webpack_public_path__ + "media/images/austrian/offers/digital-voucher1x-6154f2672eb89412035f306e0e7cb200.jpg";